import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

import * as bootstrap from "bootstrap";
import SimpleBar from 'simplebar';

// Toggle das permissoes
document.addEventListener("click", event => {
  if (!event.target.closest("#toggle-all-permissions")) return

  const collapses = document.querySelectorAll(".card .collapse")

  // Se existir pelo menos um fechado, abre todos
  const shouldOpenAll = [...collapses].some(
    collapse => !collapse.classList.contains("show")
  )

  collapses.forEach(collapse => {
    const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapse)

    if (shouldOpenAll) {
      bsCollapse.show()
    } else {
      bsCollapse.hide()
    }
  })
})

document.addEventListener("turbo:load", () => {
  // Reattach dropdown JS behavior
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((el) => {
    // Avoid duplicate instances
    if (!bootstrap.Dropdown.getInstance(el)) {
      new bootstrap.Dropdown(el);
    }
  });

  // Reinitialize SimpleBar inside the dropdown if used
  document.querySelectorAll(".profile-dropdown[data-simplebar]").forEach((el) => {
    if (!el.SimpleBar) {
      new SimpleBar(el);
    }
  });
});

//Readonly pro Trix(richtext)
document.addEventListener("trix-initialize", (event) => {
  const editor = event.target;
  if (editor.dataset.readonly === "true" || editor.dataset.readonly === true) {
    editor.setAttribute("contenteditable", "false");
    editor.toolbarElement?.remove(); // optional: hide toolbar completely
  }
});
